import { MonetizableEnum } from '@repo/supergraph/marketplace/enums';
import { SummaryTableRowType } from '@repo/supergraph/roundup/base/types';
import { SummaryTableSectionProps } from '../SummaryTable/SummaryTableSection';

export function getShowLessMonetizingOffersProps(
  rows: SummaryTableRowType[],
): Partial<SummaryTableSectionProps> {
  const MIN_ROWS_FOR_COLLAPSE = 4;
  const nonMonetized = rows.filter(
    o => o.marketplaceEntity.monetizable !== MonetizableEnum.yesAssumed,
  );

  if (rows.length <= MIN_ROWS_FOR_COLLAPSE || !nonMonetized.length) {
    return {};
  }

  const monetized = rows.filter(
    o => o.marketplaceEntity.monetizable === MonetizableEnum.yesAssumed,
  );

  return {
    allowTruncatingRows: true,
    numTruncatedRows: monetized.length + 1,
    isAccordionActiveButtonActive: true,
  };
}

export function getShowSevenOffersInSummaryTableProps(): Partial<SummaryTableSectionProps> {
  const NUM_OF_ROWS_TO_DISPLAY = 7;
  return {
    allowTruncatingRows: true,
    numTruncatedRows: NUM_OF_ROWS_TO_DISPLAY,
    isAccordionActiveButtonActive: true,
    allowTruncationWithFilters: true,
  };
}
